import Modal from 'components/Modal/Modal';
import theme from 'themes';
import { ModalSize, PartQuote } from 'types';
import {
  DetailTitleContainer,
  ModalButtonsContainer,
  QuoteModalBody,
  QuoteModalFooter,
} from './NewSFOrdersTableStyled';
import Button from 'components/Button';
import FileViewer from 'common/components/FileViewer';
import Typography from 'components/Typography/Typography';
import styledTheme from 'common/theme';
import { IcoDownload } from 'icons/indexed-icons/IcoDownload';
import { TFunction } from 'i18next';

interface ModalProps {
  showQuoteDetails: boolean;
  hideQuoteModal: () => void;
  downloadQuoteDetails: (link: string) => void;
  t: TFunction;
  quoteItem?: PartQuote;
}
function DefaultHeader() {
  return (
    <DetailTitleContainer>
      <Typography mb={0} weight="semi-bold" size="1.25rem">
        Quote Details
      </Typography>
    </DetailTitleContainer>
  );
}
const QuotePdfModal = ({
  showQuoteDetails,
  hideQuoteModal,
  downloadQuoteDetails,
  t,
  quoteItem
}: ModalProps): JSX.Element=> {

  return (
    <>
      <Modal
        onClose={hideQuoteModal}
        size={ModalSize.SMALL}
        visible={showQuoteDetails as boolean}
        allowContentScroll={true}
        closeBtnPos={{
          top: '1.7rem',
          right: '2rem'
        }}
      >
        <QuoteModalBody>

          <div style={{ flex: 1, height: '100%' }}>
            <FileViewer
              headerComponent={DefaultHeader}
              height="100%"
              previewUrl={quoteItem?.linkToPdfInBlobStorage}
            />
          </div>
        </QuoteModalBody>
        <QuoteModalFooter>
          <ModalButtonsContainer>
            <Button
              variant="text"
              color={styledTheme.JBTColors.mainColor}
              onClick={() => {
                downloadQuoteDetails(quoteItem?.linkToPdfInBlobStorage as string);
              }}
              icon={<IcoDownload />}
            >
              {t('download_pdf', { ns: 'fpns'}) as string}
            </Button>
            <Button
              onClick={() => {
                hideQuoteModal();
              }}
              bgColor={theme.colors.mediumBlue}
              height="2.5rem"
              variant="filled-primary"
            >
              {t('close') as string}
            </Button>
          </ModalButtonsContainer>
        </QuoteModalFooter>
      </Modal>
    </>
  );
};

export default QuotePdfModal;
